<template>
    <div class="notice_details_box">

        <div class="w_box content_box">
            <div class="title_box">
                <div class="title">{{noticeItem.title}}</div>
                <div class="time">{{dayjs(noticeItem.createTime).format("YYYY-MM-DD HH:mm:ss")}}</div>
            </div>
            <div class="value_box" v-html="noticeItem.content"></div>
        </div>

    </div>
</template>

<script setup> 
import { ref } from "vue"; 
import { CloseOutlined } from '@ant-design/icons-vue';
import dayjs from "dayjs";
const noticeItem = ref({});
noticeItem.value = JSON.parse(localStorage.getItem("noticeItemData"));  

function closeChange() {
    window.close();
}

</script>

<style lang="scss" scoped> 
@import "@/style/var.scss";
.w_box { 
    margin: 0 auto; 
    width: 1150px; 
} 

.notice_details_box { 
    width: 100%; 
    height: 100%;
    overflow: hidden;
    position: relative;
} 

.content_box { 
    margin: 30px auto; 
    padding: 30px;
    .title_box {
        text-align: center;
        .title {
            color: #666666; 
            font-size: 26px; 
        }
        .time {
            margin-top: 10px;
            font-size: 16px; 
            color: #999999;
        }
    }
    .value_box {
        padding: 30px 20px;
    }
} 

</style> 
